import { generateId, showConfirmation } from './confirmation-store';
import type { ConfirmActionOptions, ConfirmOptions } from './types';

export function confirm(options: ConfirmOptions): Promise<boolean> {
  const {
    title,
    description,
    variant = 'destructive',
    icon,
    confirmLabel = 'Confirm',
    confirmVariant,
    cancelLabel = 'Cancel',
    children,
  } = options;

  const actionVariant = confirmVariant ?? (variant === 'destructive' ? 'destructive' : 'primary');

  return new Promise<boolean>((resolve) => {
    showConfirmation({
      id: generateId(),
      variant,
      icon,
      title,
      description,
      children,
      cancelLabel,
      actions: [
        {
          label: confirmLabel,
          variant: actionVariant,
          onPress: () => {},
        },
      ],
      resolve: (result) => resolve(result !== false),
    });
  });
}

export function confirmAction(options: ConfirmActionOptions): Promise<string | false> {
  const {
    title,
    description,
    variant = 'default',
    icon,
    actions,
    cancelLabel = 'Cancel',
    children,
  } = options;

  return new Promise<string | false>((resolve) => {
    showConfirmation({
      id: generateId(),
      variant,
      icon,
      title,
      description,
      children,
      cancelLabel,
      actions: actions.map((a) => ({
        label: a.label,
        variant: a.variant,
        icon: a.icon,
        onPress: () => {},
      })),
      resolve: (result) => resolve(result),
    });
  });
}
